package com.cs.ejobin.data

import com.cs.ejobin.model.UserProfile

sealed class SignupResult {
    data class SignedIn(val profile: UserProfile) : SignupResult()
    data object NeedsEmailConfirmation : SignupResult()
}

interface AuthRepository {
    suspend fun login(email: String, password: String): UserProfile

    suspend fun signup(
        email: String,
        password: String,
        name: String,
        phone: String,
        skills: List<String>,
        description: String?
    ): SignupResult

    suspend fun requestPasswordReset(email: String)
    suspend fun updatePassword(newPassword: String)
    suspend fun logout()
}